import { Box, IconButton } from "@mui/material";
import { formatDate } from "../../utils/formatDate";
import { getTicketTypeByValue } from "../../constants/enums";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';

const applicationsColumns = ( handleApply, handleEdit, handleSeeApplications, handleView, colors) => [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "lote_name",
    headerName: "Lote",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "location",
    headerName: "Bloques",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "programmed_date",
    headerName: "Programada",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "applied_date",
    headerName: "Aplicada",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const noApplied = 'Sin aplicar';
      const dateInfo = params.value ? params.value : noApplied
      const color = dateInfo === noApplied ? "#ea3329" : "#4cceac"
      return (
        <Box
          sx={{
            color: color,
            fontWeight: "bold",
            backgroundColor: `${color}30`,
            border: color,
            borderRadius: "8px",
            padding: "8px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50%",
            height: "50%",
            textShadow: `0 0 30px ${color}`,
            overflow: "hidden",
          }}
        >
          {dateInfo === noApplied ? noApplied : formatDate(dateInfo)}
        </Box>
      );

    },
  },
  {
    field: "ticket_type",
    headerName: "Tipo",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const typeInfo = getTicketTypeByValue(params.value);
  
      return (
        <Box
          sx={{
            color: typeInfo.color,
            fontWeight: "bold",
            backgroundColor: `${typeInfo.color}30`, // Transparent background
            border: ` ${typeInfo.color}`, // Corner borders
            borderRadius: "8px", // Rounded corners
            padding: "8px",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50%",
            height: "50%",
            textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
            overflow: "hidden", // Prevent shadow from going outside the box
          }}
        >
          {typeInfo.label}
        </Box>
      );
    },
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 1,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton
          onClick={() => handleApply(params.row.id)}
          sx={{ color: colors.grey[100], cursor: !params.row.applied_date ? 'pointer' : 'not-allowed' }}
          disabled={!!params.row.applied_date}
        >
          <AssignmentTurnedInOutlinedIcon />
        </IconButton>
        <IconButton
          onClick={() => handleEdit(params.row.id)}
          sx={{ color: colors.grey[100], cursor: !params.row.applied_date ? 'pointer' : 'not-allowed' }}
          disabled={!!params.row.applied_date}
        >
          <EditOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleSeeApplications(params.row.id)}>
          <FormatListBulletedOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleView(params.row.id)} sx={{ color: colors.grey[100] }}>
          <VisibilityOutlinedIcon />
        </IconButton>
      </Box>
    ),
  }
];

export { applicationsColumns };
